import { useMemo, useCallback } from 'react';

import { useOperatorData } from '@contexts/operator/OperatorDataContext';

import operatorProductLabelTemplateService from '@services/operator/productLabelTemplateService';

/**
 * Operator Product Label Template Service Hook
 *
 * Wraps operatorProductLabelTemplateService with merchant context
 *
 * @returns {Object} productLabelTemplateService with merchant context
 *
 * @example
 * const productLabelTemplateService = useOperatorProductLabelTemplateService();
 *
 * await productLabelTemplateService.create({ name: 'Label Template A', content: '...' });
 * await productLabelTemplateService.getById(1);
 */
export default function useOperatorProductLabelTemplateService() {
  const { currentMerchant } = useOperatorData();

  const create = useCallback(
    (data) => {
      return operatorProductLabelTemplateService.create(data, currentMerchant?.id);
    },
    [currentMerchant?.id]
  );

  return useMemo(
    () => ({
      ...operatorProductLabelTemplateService,
      create
    }),
    [create]
  );
}
